export const getPXLDashboardRoute = () => '/';
export const getPXLLoginRoute = () => '/login';
export const getPXLPwdForget = () => '/password-forgotten';
export const getPXLContactRoute = () => '/contact-us';
export const getPXLJoinRoute = (groupLink = null, artistLink = null) => '/join/' + (groupLink ?? ':groupLink') + '/' + (artistLink ?? ':artistLink');
